// The deliverables a Modeling Process stage can carry: where each one's versions, upload dates and
// original file names live in the stage, which files it takes and how it looks. Each kind numbers
// its own versions
export const DELIVERABLE_KINDS = {
  report: {
    urlsKey: 'fileUrls',
    datesKey: 'fileUploadDates',
    namesKey: 'fileNames',
    labelKey: 'report',
    icon: 'mdi-file-chart-outline',
    color: 'blue',
    mimeTypes: { 'text/html': 'html' },
    extensions: ['html', 'htm']
  },
  modelReport: {
    urlsKey: 'modelReportUrls',
    datesKey: 'modelReportUploadDates',
    namesKey: 'modelReportNames',
    labelKey: 'modelReport',
    icon: 'mdi-file-excel-outline',
    color: 'green',
    mimeTypes: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'application/vnd.ms-excel': 'xls'
    },
    extensions: ['xlsx', 'xls']
  },
  inputsReport: {
    urlsKey: 'inputsReportUrls',
    datesKey: 'inputsReportUploadDates',
    namesKey: 'inputsReportNames',
    labelKey: 'inputsReport',
    icon: 'mdi-file-table-outline',
    color: 'teal',
    mimeTypes: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'application/vnd.ms-excel': 'xls'
    },
    extensions: ['xlsx', 'xls'],
    // Spreadsheets named like this are pre-assigned to this kind (see preassignDeliverables)
    namePattern: /input/i
  }
}

export const SPREADSHEET_KINDS = ['modelReport', 'inputsReport']

// How many spreadsheets one upload can take: one Excel Model Report and one Inputs Report
export const MAX_SPREADSHEETS_PER_UPLOAD = 2

// The kinds a file could be, by MIME type or, when the browser gives none, by extension. Null when no
// kind takes it
export function classifyDeliverable (file) {
  const extension = file.name.split('.').pop().toLowerCase()
  let kinds = []
  let fileExtension = null
  Object.keys(DELIVERABLE_KINDS).forEach(kind => {
    const config = DELIVERABLE_KINDS[kind]
    const match = config.mimeTypes[file.type] || (config.extensions.includes(extension) ? extension : null)
    if (match) {
      kinds.push(kind)
      fileExtension = match
    }
  })
  if (kinds.length === 0) {
    return null
  }
  return { kinds: kinds, extension: fileExtension }
}

export function isSpreadsheetItem (item) {
  return item.kinds.length > 1
}

// Sets the kind each classified file starts with in the upload dialog. Spreadsheets are only
// pre-assigned when their names settle it: a lone one is an Inputs Report if named "input" and an
// Excel Model Report otherwise; of two, only when exactly one is named "input". Any other pair starts
// unassigned, so that the user has to pick rather than accept a guess
export function preassignDeliverables (items) {
  const pattern = DELIVERABLE_KINDS.inputsReport.namePattern
  const spreadsheets = items.filter(isSpreadsheetItem)
  const inputs = spreadsheets.filter(item => pattern.test(item.file.name))
  items.forEach(item => {
    if (!isSpreadsheetItem(item)) {
      item.kind = item.kinds[0]
    } else if (spreadsheets.length === 1 || (spreadsheets.length === 2 && inputs.length === 1)) {
      item.kind = pattern.test(item.file.name) ? 'inputsReport' : 'modelReport'
    } else {
      item.kind = null
    }
  })
  return items
}

export function deliverableCount (stage) {
  return Object.values(DELIVERABLE_KINDS).reduce((total, config) => total + ((stage && stage[config.urlsKey]) || []).length, 0)
}
